import { render } from "./IndexGarage.vue?vue&type=template&id=4b90bb19"
import script from "./IndexGarage.vue?vue&type=script&lang=js"
export * from "./IndexGarage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__